import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import './CandidatoInfo.css';
import { executeVote } from '../services/executeVote';
import { getCandidates } from '../services/candidates';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import { usePromiseTracker } from "react-promise-tracker";
import parse from 'html-react-parser';
import { FaPowerOff } from 'react-icons/fa';
import { FaArrowLeft } from 'react-icons/fa';
import { MdOutlineRefresh } from "react-icons/md";
import { useAuth } from '../AuthContext/AuthContext'
import useWindowDimensions from '../hooks/useWindowDimensions';
import TwoOptionArrayCard from './TwoOptionArrayCard';
import TwoOptionCard from './TwoOptionCard';
import ClientCard from './ClientCard';
import Opcion6 from '../Card/Opcion6';

import {
  useParams
} from "react-router-dom";

export default function CandidatoInfo() {
  const { dispatch } = useAuth();
  const [candidates, setCandidates] = useState([]);
  const [availableVotes, setAvailableVotes] = useState([]);
  const [estateVotes, setEstateVotes] = useState([]);
  const { promiseInProgress } = usePromiseTracker();
  const [clase, setClase] = useState([]);
  const [used, setUsed] = useState(false);
  let { id } = useParams();
  let history = useHistory();
  const location = useLocation()

  const { width } = useWindowDimensions();



  function Loggout() {
    localStorage.clear();
    history.push("/login");
  }

  function back() {
    setTimeout(() => {
      history.push("/transmision");
    }, 500);

  }

  let actualizar = () => {
    getCandidates(id, dispatch.cif, dispatch.token)
      .then(response => {
        setCandidates(response.body);

        if (response.body.length > 0) {
          setAvailableVotes(response.body[0].disponible);
          setEstateVotes(response.body[0].estado);
          setClase(response.body[0].clase)

        }

      })
  }

  useEffect(() => {
    let mounted = true;
    actualizar();
    return () => mounted = false;
  }, [])

  const vote = (candidateId, candidateName, buton, candidateId2) => {
    if (candidateId2) {
      const button = document.getElementById(candidateId2);
      button.disabled = true;
    }
    buton.target.disabled = true;
    executeVote(candidateId, dispatch.cif, dispatch.token)
      .then(result => {
        setUsed(true);
        confirmVote(candidateName, result.body, result.disponible);
      })
  }

  const voteNoConfirm = (candidateId) => {
    executeVote(candidateId);
  }

  const askForVote = (candidateId, candidateName, buton, text, label, candidateId2) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h3>{parse(text)}</h3>
            <div>
              <button className="no-botton button-modal" onClick={onClose}>Regresar</button>
              <button
                className="button-modal"
                onClick={() => {
                  vote(candidateId, candidateName, buton, candidateId2);
                  onClose();
                }}
              >
                {label}
              </button>
            </div>
          </div>
        );
      }
    });
  }


  const askForPresent = (candidateId, candidateName, buton) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>{"¿Desea confirmar su participación?"}</h1>
            <div>
              <button className="no-botton button-modal" onClick={onClose}>Regresar</button>
              <button
                className="button-modal"
                onClick={() => {
                  vote(candidateId, candidateName, buton);
                  onClose();
                }}
              >
                Si
              </button>
            </div>
          </div>
        );
      }
    });
  }

  const askForKnow = (candidateId, candidateName, buton) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <h1>{"¿Da por conocido el informe?"}</h1>
            <div>
              <button className="no-botton button-modal" onClick={() => {
                onClose();
                vote(candidateId, candidateName, buton);
              }}>Regresar</button>
              <button
                className="button-modal"
                onClick={() => {
                  vote(candidateId, candidateName, buton);
                  voteNoConfirm(22);
                  onClose();
                }}
              >
                Si
              </button>
            </div>
          </div>
        );
      }
    });
  }

  function Cerrar(onClose) {

    if (availableVotes === 1)
      back();
    onClose();
  }

  const confirmVote = (candidateName, body, available) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        let message;
        if (clase === 0) {
          if (body === "Allow") {
            message = "Su voto fue emitido correctamente a favor de " + candidateName
            setAvailableVotes(available);
          } else if (body === "Uninitiated") {
            message = "Su voto a favor de " + candidateName + " no pudo ser emitido, la votación no ha iniciado."
          } else if (body === "Finalized") {
            message = "Su voto a favor de " + candidateName + " no pudo ser emitido, la votación ha finalizado."
          } else if (body === "Voted" && available > 0) {
            message = "Su voto a favor de " + candidateName + " ya fue emitido con anterioridad, no puede votar por el mismo candidato."
          } else if (body === "Voted" && available === 0) {
            message = "No cuentas con votos disponibles para esta categoría.";
          } else {
            message = "Su voto a favor de " + candidateName + " no pudo ser emitido"
          }
        } else if (clase === 1) {
          if (body === "Allow") {
            message = "Muchas gracias por su confirmación."
            setAvailableVotes(available);
          } else if (body === "Uninitiated") {
            message = "No se puede emitir su confirmación, la votación no ha iniciado."
          } else if (body === "Finalized") {
            message = "No se puede emitir su confirmación, la votación ha finalizado."
          } else if (body === "Voted" && available > 0) {
            message = "No se puede emitir su confirmación."
          } else if (body === "Voted" && available === 0) {
            message = "No cuentas con votos disponibles para esta categoría.";
          } else {
            message = "No se puede emitir su confirmación."
          }
        } else if (clase === 2) {
          if (body === "Allow") {
            message = "Muchas gracias por su voto."
            setAvailableVotes(available);
          } else if (body === "Uninitiated") {
            message = "No se puede emitir su voto, la votación no ha iniciado."
          } else if (body === "Finalized") {
            message = "No se puede emitir su voto, la votación ha finalizado."
          } else if (body === "Voted" && available > 0) {
            message = "No se puede emitir su voto."
          } else if (body === "Voted" && available === 0) {
            message = "No cuentas con votos disponibles para esta categoría.";
          } else {
            message = "No se puede emitir su voto."
          }
        } else if (clase === 3) {
          if (body === "Allow") {
            message = "Muchas gracias por su confirmación."
            setAvailableVotes(available);
          } else if (body === "Uninitiated") {
            message = "No se puede emitir su confirmación, la votación no ha iniciado."
          } else if (body === "Finalized") {
            message = "No se puede emitir su confirmación, la votación ha finalizado."
          } else if (body === "Voted" && available > 0) {
            message = "No se puede emitir su confirmación."
          } else if (body === "Voted" && available === 0) {
            message = "No cuentas con votos disponibles para esta categoría.";
          } else {
            message = "No se puede emitir su confirmación."
          }
        } else if (clase === 5 || clase === -1) {
          if (body === "Allow") {
            message = "Su voto fue realizado correctamente"
            setAvailableVotes(available);
          } else if (body === "Uninitiated") {
            message = "No se puede emitir su voto, la votación no ha iniciado."
          } else if (body === "Finalized") {
            message = "No se puede emitir su voto, la votación ha finalizado."
          } else if (body === "Voted" && available > 0) {
            message = "No se puede emitir su voto."
          } else if (body === "Voted" && available === 0) {
            message = "No se cuenta con votos disponibles.";
          } else {
            message = "No se puede emitir su voto."
          }
        }


        return (
          <div className='custom-ui '>
            <h3>{message}</h3>
            <div className="button-container">
              <button className="button-modal center" onClick={e => Cerrar(onClose)}>Regresar</button>
            </div>
          </div>
        );
      }
    });
  }

  const trucateText = (text) => {
    let text2 = text;
    const myArray = text.split(".");

    if (myArray.length > 1)
      return parse(myArray[0] + '.');
    else
      return parse(text2);

  }

  const seeMore = (candidate) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='see-more-container'>
            <h1 className="see-more-name">{candidate.Nombre}</h1>
            <img className="see-more-image" src={candidate.Foto} alt={candidate.Nombre}></img>
            <div className="see-more-description">{parse(candidate.Descripcion)}</div>
            <div className="see-more-button-container">
              <button className="button-modal center" onClick={onClose}>Regresar</button>
            </div>
          </div>
        );
      }
    });
  }




  function getAvailableVotes() {
    let message = promiseInProgress ? "" : "No cuentas con votos disponibles para esta categoría.";

    if (availableVotes > 0) {
      message = "Tienes disponible " + availableVotes + (availableVotes === 1 ? " voto" : " votos") + " para esta categoría.";
    }

    if (estateVotes === "Finalized") {
      message = "Votación finalizada, muchas gracias por su participación."
    }

    if (estateVotes === "Uninitiated") {
      message = "La votación no ha iniciado, debes de estar pendiente de las instrucciones del moderador."
    }



    return message;
  }

  return (
    <div>
      <div className='wrap header'>
        <button className={"button-small back"} onClick={back}><FaArrowLeft /> Regresar</button>
        <div className='logoContainer'>
          {width < 700 ? (
            <div>
              <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo-no" alt="Guadalupana"></img>
            </div>
          ) : (
            <div>
              <img src="https://guadalupanabucket.s3.us-east-2.amazonaws.com/logo_header.png" className="logo" alt="Guadalupana"></img>
            </div>
          )
          }
        </div>
        {(location.pathname !== '/login' && location.pathname !== '/registro') ?
          <div>
            {width < 500 && (location.pathname.includes("candidato") || location.pathname.includes("campana")) ? (
              <div></div>
            ) : (
              <button className="button-small logout" onClick={actualizar}><MdOutlineRefresh /> Actualizar</button>
            )}
            <button className={"button-small logout"} onClick={Loggout}><FaPowerOff />  Salir </button>
          </div> :
          <div></div>
        }
      </div>
      <div className="main">

        {clase != 6 ? <h1 className="welcome_message"> {getAvailableVotes()}</h1> : <div></div>}

        <LoadingIndicator />

        <div className="container-list">
          {clase === 6 ? (
            <Opcion6 getAvailableVotes={getAvailableVotes} candidates={candidates} askForVote={askForVote} />
          ) : clase === 2 ? (
            <TwoOptionCard
              candidates={candidates}
              used={used}
              askForVote={askForVote}
            />
          ) : (clase === 5 || clase === -1) ? (
            candidates.map((can, index) => {
              if (index % 2 === 0 && index + 1 < candidates.length) {
                can.Nombre = can.Nombre.replace('Si -', '').replace('No -', '');
                let can1 = can;
                let can2 = candidates[index + 1];

                return <TwoOptionArrayCard
                  key={can1.IDCandidato}
                  candidate1={can1}
                  candidate2={can2}
                  seeMore={seeMore}
                  askForVote={askForVote}
                />;
              } else {
                return null;
              }
            }).filter(result => result !== null)
          ) : (
            candidates.map(can =>
              <ClientCard
                key={can.IDCandidato}
                candidate={can}
                candidates={candidates}
                used={used}
                availableVotes={availableVotes}
                askForVote={askForVote}
                seeMore={seeMore}
                askForKnow={askForKnow}
                askForPresent={askForPresent}
              />
            )
          )}
        </div>
      </div>
    </div>

  )
}
